import React from 'react';
import CrudPage from '../../../components/CrudPage';
import useLookups from '../../../hooks/useLookups';
import { AUDIT_COLUMNS, accountCodeLabel } from '../../../config/columns';
import { incomeTypeService, accountCodeService } from '../../../services/resources';

export default function IncomeTypePage({ onToast }) {
  const lookups = useLookups({
    accountCodes: { service: accountCodeService, labelKey: accountCodeLabel },
  });
  const codeLabel = (id) => lookups.accountCodes?.find((o) => o.value === id)?.label ?? id;

  return (
    <CrudPage
      title="Income Type"
      formCode="INCOME_TYPE"
      service={incomeTypeService}
      onToast={onToast}
      lookups={lookups}
      searchKeys={['name', 'description']}
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'account_code_id', label: 'Account Code', render: (r) => codeLabel(r.account_code_id) },
        { key: 'description', label: 'Description' },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        { key: 'name', label: 'Name', type: 'text', required: true, immutableOnEdit: true, uppercase: true },
        { key: 'account_code_id', label: 'Account Code', type: 'select', required: true, lookup: 'accountCodes' },
        { key: 'description', label: 'Description', type: 'textarea' },
      ]}
    />
  );
}
